import { useState, useEffect, useRef } from 'react';
import { FaCartShopping } from 'react-icons/fa6';
import { useCart } from '../../../api/queryHooks/order';
import { useNavigate } from 'react-router';
import { Loader } from '@f2m3/shared-frontend-ui';
import CartIndicatorBody from './CartIndicatorBody';
import { useClickOutside } from '../../../hooks/useClickOutside';

import './CartIndicator.scss';

const CartIndicator = () => {
  const [ open, setOpen ] = useState(false);
  const [ animate, setAnimate ] = useState(false);
  const { data, isLoading } = useCart();
  const ref = useClickOutside<HTMLDivElement>(() => setOpen(false));
  const navigate = useNavigate();
  const itemCount = data?.line_items?.length || 0;
  const prevItemCountRef = useRef(itemCount);

  const gotoOrder = () => {
    setOpen(false);
    navigate("/order");
  }

  // Trigger animation when item count increases
  useEffect(() => {
    if (itemCount > prevItemCountRef.current) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 300);
      return () => clearTimeout(timer);
    }
    prevItemCountRef.current = itemCount;
  }, [itemCount]);

  return (
    <>
      <div ref={ref}>
        <div className="cart-indicator" onClick={ () => setOpen(!open) }>
          { isLoading ? (
            <Loader />
          ) : (
            <div className={`cart-icon-wrapper ${animate ? 'cart-icon-bounce' : ''}`}>
              <FaCartShopping size={20} />
              {itemCount > 0 && (
                <span className="cart-badge">{itemCount}</span>
              )}
            </div>
          )}
        </div>
        { open && <CartIndicatorBody gotoOrderClick={gotoOrder}/> }
      </div>
    </>
  );
}

export default CartIndicator;
